import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.css'],
	animations: [loadingFade, modal, alert]
})
export class DashboardComponent implements OnInit {

	public loading = false;

	constructor() { }

	ngOnInit() {
	}
}